.IntroductionRenku20Bg {
  background-image: url("../../assets/dividerDots.svg");
}

.IntroductionRenku20Sections {
  max-width: 1200px;
  margin: auto;
}
